import { render, staticRenderFns } from "./AscPagePlotsWrapper.vue?vue&type=template&id=381fe0d2&"
import script from "./AscPagePlotsWrapper.vue?vue&type=script&lang=js&"
export * from "./AscPagePlotsWrapper.vue?vue&type=script&lang=js&"
import style0 from "./AscPagePlotsWrapper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports